module.exports = __webpack_public_path__ + "img/4064010620.141abc27.jpg";